import { useEffect, useState } from "react";
import { Box, Card, CardContent, CardHeader, Typography, Avatar, Grid, Button, DialogContent } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonIcon from "@mui/icons-material/Person";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useDispatch, useSelector } from "react-redux";
import { getWorkFlowDetailsService } from "../../../utils/services/workflow.service.ts/workflow-service";
import { closeDialog, openDialog } from "../../../redux/reducer/dialogSlice";
import GlobalDialogContent from "../GlobalDialogContent";
import { RootState } from "../../../redux/store";
import { DonorConfig } from "../../../constant/config";

const groupWorkflowsByLevel = (workflows: any) => {
    const result: Record<number, any[]> = {};
    workflows?.approvers?.forEach((approver: any) => {
        if (!result[approver.level]) { result[approver.level] = []; }
        result[approver.level].push({
            ...approver,
            module_name: approver.module_name,
            department_name: approver.department_name,
        });
    });

    return result;
};

const WorkflowHierarchy = ({ workflows }: { workflows: any }) => {
    const groupedApprovers = groupWorkflowsByLevel(workflows);

    return (
        <Box sx={{ mx: 2 }}>
            <Box sx={{ mx: 2 }}>
                {Object.entries(groupedApprovers).sort(([a], [b]) => Number(a) - Number(b)).map(([level, approvers]) => (
                    <Card variant="outlined" key={level} sx={{ marginBottom: 2, border: "2px dashed #ddd", borderRadius: 2, }} >
                        <CardContent>
                            <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold", color: "primary.main" }} > Level {level} </Typography>
                            <Grid container spacing={4}>
                                {(approvers as any[])?.map((approver, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <Card sx={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,.25)", height: "100%", }} >
                                            <CardHeader
                                                avatar={<Avatar sx={{ bgcolor: "secondary.main" }}> <PersonIcon /> </Avatar>}
                                                title={
                                                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                                        {approver.approver_name || "--"}
                                                        {approver.role_name
                                                            ? ` (${approver.role_name})`
                                                            : ""}
                                                        {approver.is_dependent === "Y"
                                                            ? " (Dependent)"
                                                            : approver.is_dependent === "N"
                                                                ? " (Independent)"
                                                                : ""}
                                                    </Typography>
                                                }
                                                subheader={
                                                    <Typography variant="body2" color="text.secondary">
                                                        {DonorConfig[approver.role_user_type]}
                                                    </Typography>
                                                }
                                            />
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    </Card>
                ))}
            </Box>
        </Box>
    );
};

export default function WorkFlowDetails() {
    const dispatch = useDispatch();
    const { payload } = useSelector((state: RootState) => state.dialog);
    const [workflows, setWorkflows] = useState<any>({});

    useEffect(() => {
        const getWorkFlowDetails = async () => {
            if (payload) {
                const req_payload = { uuid: payload?.uuid, module_id: payload.module_id, ...(payload?.department_id && { department_id: payload.department_id }) };
                const { data, code } = await getWorkFlowDetailsService(req_payload);
                if (code === 200 && data) {
                    setWorkflows(data);
                }
            }
        }
        getWorkFlowDetails();
    }, [payload])

    const handleEditWorkFlowMaster = (row: any) => {
        dispatch(openDialog({ type: 'EditWorkFlowMaster', title: 'Update Workflow Master', isFullScreen: true, payload: { workflowMaster: row } }));
    }

    const handleBack = () => {
        dispatch(closeDialog());
    }

    return (
        <GlobalDialogContent
            dialogBody={
                <>
                    <DialogContent sx={{ p: 0 }}>
                        <Button onClick={handleBack} sx={{ p: 1 }} startIcon={<ArrowBackIcon sx={{ color: 'blue', }} />}>
                            Back
                        </Button>
                        <Box>
                            <Box>
                                <Card elevation={0}>
                                    <CardHeader
                                        title={
                                            <>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} sm={6} sx={{ textAlign: 'left', }}>

                                                        {workflows?.module_name}
                                                        {workflows?.department_name ? ` (${workflows?.department_name})` : ''}
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} display={"flex"} justifyContent={"flex-end"}>
                                                        <Button variant="outlined" color="primary" endIcon={<EditOutlinedIcon color='info' />} onClick={() => handleEditWorkFlowMaster(payload)} >
                                                            Edit Workflow
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }
                                    />
                                </Card>
                            </Box>
                            <Box sx={{ maxHeight: "78vh", overflowY: "auto" }}>
                                <WorkflowHierarchy workflows={workflows} />
                            </Box>
                        </Box>
                    </DialogContent>
                </>
            }
        />
    );
}